module.exports = __webpack_public_path__ + "media/Video 63.a36e4e60.mp4";